export default "__VITE_ASSET__CmKS915L__"